import React from "react";
import "./index.css";
import "react-toastify/dist/ReactToastify.css";
import ReactDOM from "react-dom/client";
import { ToastContainer } from "react-toastify";
import SignUp from "./pages/signup/SignUp";
import Dashboard from "./pages/dashboard/Dashboard";
import Landing from "./pages/landing/Landing";
import Shop from "./pages/shop/Shop";
import Cart from "./pages/shop/Cart";
import RaidSignups from "./pages/raidSignups/RaidSignups";
import RaidSignupAuditLog from "./pages/raidSignups/RaidSignupAuditLog";
import RaidStatistics from "./pages/raidStatistics/RaidStatistics";
import RaidReportDetail from "./pages/raidStatistics/RaidReportDetail";
import RaidCharacterStats from "./pages/raidStatistics/RaidCharacterStats";
import AdminRoute from "./components/AdminRoute";
import PrivateRoute from "./components/PrivateRoute";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import { UserProfileProvider } from "./context/UserProfileContext";
import { SelectedCharacterProvider } from "./context/SelectedCharacterContext";
import { CartProvider } from "./context/CartContext";
import Tournaments from "./pages/dashboard/Tournaments";
import TournamentsHub from "./pages/dashboard/TournamentsHub";
import ManageTournaments from "./pages/dashboard/ManageTournaments";
import TournamentStandings from "./pages/dashboard/TournamentStandings";
import Account from "./pages/dashboard/Account";
import PastTournaments from "./pages/dashboard/PastTournaments";
import PastTournamentResults from "./pages/dashboard/PastTournamentResults";
import SoloDuoRanking from "./pages/dashboard/SoloDuoRanking";
import SoloDuoStandings from "./pages/dashboard/SoloDuoStandings";
import SoloDuoManageRegistration from "./pages/dashboard/SoloDuoManageRegistration";
import SoloDuoInvitations from "./pages/dashboard/SoloDuoInvitations";
import SoloDuoRules from "./pages/dashboard/SoloDuoRules";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <LanguageProvider>
    <UserProfileProvider>
      <SelectedCharacterProvider>
        <CartProvider>
          <Router>
            <ToastContainer position="bottom-right" theme="colored" />
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/cart" element={<Cart />} />
              <Route
                path="/raid-signups"
                element={
                  <PrivateRoute>
                    <RaidSignups />
                  </PrivateRoute>
                }
              />
              <Route
                path="/raid-signups/audit-log"
                element={
                  <AdminRoute>
                    <RaidSignupAuditLog />
                  </AdminRoute>
                }
              />
              <Route
                path="/raid-statistics"
                element={
                  <PrivateRoute>
                    <RaidStatistics />
                  </PrivateRoute>
                }
              />
              <Route
                path="/raid-statistics/reports/:code"
                element={
                  <PrivateRoute>
                    <RaidReportDetail />
                  </PrivateRoute>
                }
              />
              <Route
                path="/raid-statistics/characters/:characterId"
                element={
                  <PrivateRoute>
                    <RaidCharacterStats />
                  </PrivateRoute>
                }
              />
              <Route path="/signup" element={<SignUp />} />
              <Route
                path="/account"
                element={
                  <PrivateRoute>
                    <Account />
                  </PrivateRoute>
                }
              />
              <Route
                path="/tournaments"
                element={
                  <PrivateRoute>
                    <TournamentsHub />
                  </PrivateRoute>
                }
              />
              <Route
                path="/tournaments/active"
                element={
                  <PrivateRoute>
                    <Tournaments />
                  </PrivateRoute>
                }
              />
              <Route
                path="/solo-duo-ranking"
                element={
                  <PrivateRoute>
                    <SoloDuoRanking />
                  </PrivateRoute>
                }
              />
              <Route
                path="/solo-duo-ranking/standings"
                element={
                  <PrivateRoute>
                    <SoloDuoStandings />
                  </PrivateRoute>
                }
              />
              <Route
                path="/solo-duo-ranking/manage-registration"
                element={
                  <PrivateRoute>
                    <SoloDuoManageRegistration />
                  </PrivateRoute>
                }
              />
              <Route
                path="/solo-duo-ranking/invitations"
                element={
                  <PrivateRoute>
                    <SoloDuoInvitations />
                  </PrivateRoute>
                }
              />
              <Route
                path="/solo-duo-ranking/rules"
                element={
                  <PrivateRoute>
                    <SoloDuoRules />
                  </PrivateRoute>
                }
              />
              <Route
                path="/past-tournaments"
                element={
                  <PrivateRoute>
                    <PastTournaments />
                  </PrivateRoute>
                }
              />
              <Route
                path="/past-tournaments/:id"
                element={
                  <PrivateRoute>
                    <PastTournamentResults />
                  </PrivateRoute>
                }
              />
              <Route
                path="/tournaments/:id"
                element={
                  <PrivateRoute>
                    <TournamentStandings />
                  </PrivateRoute>
                }
              />
              <Route
                path="/manage-tournaments/*"
                element={
                  <PrivateRoute>
                    <ManageTournaments />
                  </PrivateRoute>
                }
              />
              <Route
                path="/dashboard/*"
                element={
                  <PrivateRoute>
                    <Dashboard />
                  </PrivateRoute>
                }
              />
            </Routes>
          </Router>
        </CartProvider>
      </SelectedCharacterProvider>
    </UserProfileProvider>
    </LanguageProvider>
  </React.StrictMode>
);
